import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Reusable SVG Icons
const TrendUp = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline><polyline points="16 7 22 7 22 13"></polyline></svg>;
const ArrowDown = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline></svg>;
const Star = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#eab308" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>;
const Check = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>;
const XMark = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>;
const Target = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0ea5e9" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg>;

const SLIDES = [
  {
    id: 1,
    eyebrow: "PenSense",
    titlePrefix: "AI-Powered ",
    titleHighlight: "Smart Study Monitoring",
    titleSuffix: "",
    content: "Transforming Student Discipline into Measurable Success.",
    metrics: [
      { top: "Data", bottom: "Driven", icon: <TrendUp /> },
      { top: "AI", bottom: "Powered", icon: <Star /> },
      { top: "Real", bottom: "Time", icon: <Check /> }
    ],
    widget: (
      <div className="relative w-full max-w-sm mx-auto">
         {/* Background Glow */}
         <div className="absolute inset-0 bg-sky-500/20 blur-[80px] rounded-full"></div>
         
         {/* Floating Glass Dashboard */}
         <div className="relative bg-slate-900/60 border border-slate-700/50 backdrop-blur-xl rounded-2xl p-6 shadow-2xl transition-shadow duration-500 hover:shadow-[0_0_50px_rgba(14,165,233,0.3)]">
            
            {/* Header / User Mock */}
            <div className="flex items-center gap-4 mb-6 pb-4 border-b border-slate-800/80">
               <div className="h-12 w-12 rounded-full bg-gradient-to-br from-indigo-500 to-sky-400 flex items-center justify-center shadow-[0_0_20px_rgba(56,189,248,0.4)]">
                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
               </div>
               <div>
                  <p className="text-sm font-bold text-slate-100 uppercase tracking-widest">PenSense Sync</p>
                  <p className="text-xs text-sky-400 font-mono mt-1 flex items-center gap-1.5"><span className="h-1.5 w-1.5 rounded-full bg-sky-400 animate-pulse shadow-[0_0_8px_rgba(14,165,233,1)]"></span> LIVE DATA</p>
               </div>
            </div>
            
            {/* Mock Graph Data */}
            <div className="space-y-4">
               <div>
                 <div className="flex justify-between items-end mb-1">
                   <span className="text-[11px] uppercase tracking-widest text-slate-500 font-bold">Focus Score</span>
                   <span className="text-emerald-400 font-mono font-bold text-sm">94%</span>
                 </div>
                 <div className="h-2 w-full bg-slate-800 rounded-full overflow-hidden">
                   <div className="h-full bg-gradient-to-r from-emerald-500 to-sky-400 w-[94%]" />
                 </div>
               </div>
               
               <div>
                 <div className="flex justify-between items-end mb-1">
                   <span className="text-[11px] uppercase tracking-widest text-slate-500 font-bold">Session Time</span>
                   <span className="text-sky-400 font-mono font-bold text-sm">02h 15m</span>
                 </div>
                 <div className="h-2 w-full bg-slate-800 rounded-full overflow-hidden">
                   <div className="h-full bg-gradient-to-r from-sky-500 to-indigo-600 w-[75%]" />
                 </div>
               </div>
            </div>
            
            {/* Activity Heatmap Mock */}
            <div className="mt-6 pt-4 border-t border-slate-800/80">
              <p className="text-[10px] uppercase text-slate-500 font-bold tracking-widest mb-2">Recent Micro-Activity</p>
              <div className="flex gap-1 w-full overflow-hidden">
                {Array.from({length: 22}).map((_, i) => (
                  <div key={i} className={`h-8 w-2 rounded-sm ${Math.random() > 0.4 ? 'bg-sky-500/80 shadow-[0_0_6px_rgba(14,165,233,0.6)]' : 'bg-slate-800'}`} />
                ))}
              </div>
            </div>
            
         </div>
      </div>
    )
  },
  {
    id: 2,
    eyebrow: "Problem Statement",
    titlePrefix: "📉 Students Don’t Fail Suddenly — They ",
    titleHighlight: "Drift Slowly",
    titleSuffix: "",
    content: "Traditional models leave a massive blind spot. Parents and teachers rely on exams when it's already too late.",
    metrics: [],
    widget: (
      <div className="bg-rose-950/20 border border-rose-900/50 rounded-2xl p-6 shadow-xl relative backdrop-blur-md flex flex-col gap-4">
         <p className="text-rose-400 font-bold flex items-center gap-2 text-sm uppercase tracking-wider">
            "You can't fix what you can't see"
         </p>
         <ul className="space-y-3 text-slate-300">
            <li className="flex gap-3"><XMark /> <span>No visibility into daily study habits</span></li>
            <li className="flex gap-3"><XMark /> <span>Parents rely on marks after it's too late</span></li>
            <li className="flex gap-3"><XMark /> <span>Students struggle with discipline & consistency</span></li>
            <li className="flex gap-3"><XMark /> <span>Coaching/schools lack real-time engagement data</span></li>
         </ul>
      </div>
    )
  },
  {
    id: 3,
    eyebrow: "Market Insight (JEE Context)",
    titlePrefix: "🎯 The Critical ",
    titleHighlight: "11th–12th Transition",
    titleSuffix: "",
    content: "The syllabus jumps exponentially. Students feel lost, complacent, and overwhelmed within the first 6 months—causing the maximum drop in discipline.",
    metrics: [],
    widget: (
      <div className="flex flex-col gap-4">
        <div className="bg-slate-900/80 border border-slate-700/60 rounded-2xl p-6 shadow-2xl backdrop-blur-xl">
           <h3 className="text-xl font-bold text-sky-400 mb-2">Target Demographic</h3>
           <p className="text-slate-300">Class 11 & 12 Science Aspirants</p>
           <ul className="mt-4 space-y-2 text-sm text-slate-400">
             <li className="flex gap-2 items-center"><ArrowDown /> First 6 months saw maximum discipline drop</li>
             <li className="flex gap-2 items-center"><ArrowDown /> No system tracks effort vs output</li>
           </ul>
        </div>
        <div className="bg-indigo-900/30 border border-indigo-500/30 rounded-2xl p-4">
           <p className="text-indigo-300 font-medium italic text-center">
             "Success in JEE is not about intelligence — it’s about consistency."
           </p>
        </div>
      </div>
    )
  },
  {
    id: 4,
    eyebrow: "Solution",
    titlePrefix: "✍️ Introducing ",
    titleHighlight: "PenSense",
    titleSuffix: "",
    content: "An AI-enabled smart pen that tracks writing time, practice patterns, and consistency to convert offline study into actionable data.",
    metrics: [
      { top: "Tracks", bottom: "Writing Time", icon: <Check /> },
      { top: "Analyzes", bottom: "Consistency", icon: <TrendUp /> },
      { top: "Alerts", bottom: "Parents", icon: <Star /> }
    ],
    widget: (
      <div className="relative">
         <div className="bg-sky-900/20 border border-sky-500/30 rounded-2xl p-6 shadow-[0_0_40px_rgba(14,165,233,0.15)] relative backdrop-blur-md">
            <h3 className="text-sky-400 font-bold mb-4 uppercase tracking-widest text-sm">Value Proposition</h3>
            <p className="text-2xl text-slate-100 font-light mb-4">
              “From invisible effort to measurable progress.”
            </p>
            <div className="h-1 bg-gradient-to-r from-sky-400 to-indigo-600 rounded-full w-1/2"></div>
         </div>
      </div>
    )
  },
  {
    id: 5,
    eyebrow: "Product Demo Flow",
    titlePrefix: "📊 ",
    titleHighlight: "How It Works",
    titleSuffix: "",
    content: "A seamless pipeline from pen to parent. No extra steps for the student.",
    metrics: [],
    widget: (
      <div className="flex flex-col gap-3 w-full bg-slate-900/50 p-6 rounded-2xl border border-slate-700/50">
        {[
          { icon: '✍️', text: 'Student writes normally' },
          { icon: '📡', text: 'Pen tracks activity' },
          { icon: '🔄', text: 'Data synced to dashboard' },
          { icon: '🧠', text: 'AI analyzes patterns' },
          { icon: '🔔', text: 'Alerts & insights generated' }
        ].map((step, idx) => (
          <div key={idx} className="flex flex-col items-center">
            <div className="w-full bg-slate-800/80 border border-slate-700 rounded-xl p-3 flex items-center gap-4">
               <span className="text-2xl">{step.icon}</span>
               <span className="text-slate-200 font-medium">{step.text}</span>
            </div>
            {idx < 4 && <ArrowDown />}
          </div>
        ))}
      </div>
    )
  },
  {
    id: 6,
    eyebrow: "Key Features",
    titlePrefix: "🚀 Built for Real Learning, ",
    titleHighlight: "Not Just Tracking",
    titleSuffix: "",
    content: "A holistic analytics suite that empowers all stakeholders.",
    metrics: [],
    widget: (
      <div className="grid grid-cols-2 gap-4 w-full">
         {[
           "Daily practice tracking",
           "Focus detection",
           "Subject-wise analytics",
           "Early warning alerts",
           "Parent dashboard",
           "Teacher insights"
         ].map((feature, i) => (
           <div key={i} className="bg-slate-900/60 border border-slate-700/50 p-4 rounded-xl flex items-center gap-3 backdrop-blur-sm">
              <Check />
              <span className="text-sm font-medium text-slate-200">{feature}</span>
           </div>
         ))}
      </div>
    )
  },
  {
    id: 7,
    eyebrow: "Core Value Proposition",
    titlePrefix: "💡 What Makes PenSense ",
    titleHighlight: "Powerful",
    titleSuffix: "",
    content: "It's built on three fundamental pillars to drive actual student outcomes.",
    metrics: [],
    widget: (
      <div className="flex flex-col gap-6 w-full">
         <div className="bg-indigo-900/20 border border-indigo-500/30 p-5 rounded-xl shadow-lg">
            <h3 className="text-indigo-400 font-bold mb-3 flex items-center gap-2"><Target /> 3 Pillars of Success</h3>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 bg-slate-900/80 p-3 rounded-lg border border-slate-800"><span className="text-2xl font-bold text-sky-400">1</span> <span className="text-slate-200"><strong>Early Intervention:</strong> Stop failure before it happens.</span></li>
              <li className="flex items-center gap-3 bg-slate-900/80 p-3 rounded-lg border border-slate-800"><span className="text-2xl font-bold text-sky-400">2</span> <span className="text-slate-200"><strong>Behavioral Insights:</strong> Understand focus vs distraction.</span></li>
              <li className="flex items-center gap-3 bg-slate-900/80 p-3 rounded-lg border border-slate-800"><span className="text-2xl font-bold text-sky-400">3</span> <span className="text-slate-200"><strong>Discipline Building:</strong> Routine creates results.</span></li>
            </ul>
         </div>
         <p className="text-center italic text-slate-400">“We don’t just track studying — we build studying habits.”</p>
      </div>
    )
  },
  {
    id: 8,
    eyebrow: "Target Customers",
    titlePrefix: "🎯 ",
    titleHighlight: "Who We Serve",
    titleSuffix: "",
    content: "PenSense creates value for everyone in the student's ecosystem.",
    metrics: [],
    widget: (
      <div className="grid grid-cols-2 gap-4">
        {[
          { title: "Aspirants", icon: "👨‍🎓", desc: "JEE/NEET (Class 11–12)" },
          { title: "Coaching", icon: "🏢", desc: "Institutes needing outcomes" },
          { title: "Schools", icon: "🏫", desc: "For academic tracking" },
          { title: "Parents", icon: "👪", desc: "Of serious students" }
        ].map((item, i) => (
          <div key={i} className="bg-slate-900/60 border border-slate-700/50 p-5 rounded-2xl flex flex-col items-center justify-center text-center hover:border-sky-500/50 transition-colors">
            <span className="text-4xl mb-3">{item.icon}</span>
            <span className="text-base font-bold text-slate-100">{item.title}</span>
            <span className="text-xs text-slate-500 mt-1">{item.desc}</span>
          </div>
        ))}
      </div>
    )
  },
  {
    id: 9,
    eyebrow: "Business Model",
    titlePrefix: "💰 ",
    titleHighlight: "How We Make Money",
    titleSuffix: "",
    content: "A robust hardware-as-a-service model with recurring SaaS revenue.",
    metrics: [],
    widget: (
      <div className="flex flex-col gap-4 w-full">
         <div className="bg-emerald-900/20 border border-emerald-500/30 p-5 rounded-xl flex items-center justify-between">
           <div>
             <p className="text-sm font-bold text-emerald-400">Device Sale (Pen)</p>
             <p className="text-xs text-slate-400 mt-1">One-time hardware fee</p>
           </div>
           <p className="text-emerald-400 font-mono font-bold bg-emerald-500/10 px-3 py-1 rounded">₹2,999 - ₹4,999</p>
         </div>
         <div className="bg-sky-900/20 border border-sky-500/30 p-5 rounded-xl flex items-center justify-between">
           <div>
             <p className="text-sm font-bold text-sky-400">Monthly Subscription</p>
             <p className="text-xs text-slate-400 mt-1">Analytics Dashboard</p>
           </div>
           <p className="text-sky-400 font-mono font-bold bg-sky-500/10 px-3 py-1 rounded">₹199 - ₹499/mo</p>
         </div>
         <div className="grid grid-cols-2 gap-4 mt-2">
            <div className="bg-slate-900/60 border border-slate-700 p-4 rounded-xl text-center"><p className="text-slate-300 font-semibold text-sm">School/Coaching Partnerships</p></div>
            <div className="bg-slate-900/60 border border-slate-700 p-4 rounded-xl text-center"><p className="text-slate-300 font-semibold text-sm">Bulk Licensing</p></div>
         </div>
      </div>
    )
  },
  {
    id: 10,
    eyebrow: "Go-To-Market Strategy",
    titlePrefix: "🚀 ",
    titleHighlight: "How We Scale",
    titleSuffix: "",
    content: "A B2B2C distribution approach to hit critical mass quickly.",
    metrics: [],
    widget: (
      <div className="bg-slate-900/80 border border-slate-700/60 rounded-2xl p-6 shadow-2xl backdrop-blur-xl flex flex-col items-center text-center">
         <p className="text-xl font-bold text-sky-400 mb-6 uppercase tracking-wider">“Sell where the student already studies.”</p>
         <div className="flex flex-wrap justify-center gap-3">
            {["Coaching Tie-ups", "School Partnerships", "Parent Webinars", "Digital Marketing", "Demo Campaigns"].map(ch => (
              <span key={ch} className="bg-slate-800 text-slate-300 px-4 py-2 border border-slate-700 rounded-full text-sm font-medium">{ch}</span>
            ))}
         </div>
      </div>
    )
  },
  {
    id: 11,
    eyebrow: "Competitive Advantage",
    titlePrefix: "⚔️ ",
    titleHighlight: "Why PenSense Wins",
    titleSuffix: "",
    content: "Hardware-powered tracking provides irrefutable data compared to self-reporting apps.",
    metrics: [],
    widget: (
      <div className="w-full bg-slate-900/80 border border-slate-700 rounded-2xl overflow-hidden shadow-2xl">
         <table className="w-full text-left text-sm">
           <thead className="bg-slate-900/90 border-b border-slate-700">
             <tr>
               <th className="p-4 text-slate-400 font-medium">Feature</th>
               <th className="p-4 text-slate-400 font-medium text-center">Others</th>
               <th className="p-4 text-sky-400 font-bold text-center">PenSense</th>
             </tr>
           </thead>
           <tbody className="divide-y divide-slate-800">
             <tr><td className="p-4 text-slate-200">Offline tracking</td><td className="p-4 text-center"><XMark className="mx-auto" /></td><td className="p-4 text-center"><Check className="mx-auto" /></td></tr>
             <tr><td className="p-4 text-slate-200">Real-time insights</td><td className="p-4 text-center"><XMark className="mx-auto" /></td><td className="p-4 text-center"><Check className="mx-auto" /></td></tr>
             <tr><td className="p-4 text-slate-200">Habit tracking</td><td className="p-4 text-center"><XMark className="mx-auto" /></td><td className="p-4 text-center"><Check className="mx-auto" /></td></tr>
             <tr><td className="p-4 text-slate-200">Parent alerts</td><td className="p-4 text-center"><XMark className="mx-auto" /></td><td className="p-4 text-center"><Check className="mx-auto" /></td></tr>
           </tbody>
         </table>
         <div className="bg-slate-900/90 p-3 text-center text-xs text-sky-300 border-t border-slate-700">“We track effort, not just results.”</div>
      </div>
    )
  },
  {
    id: 12,
    eyebrow: "Impact",
    titlePrefix: "📊 ",
    titleHighlight: "Measurable Outcomes",
    titleSuffix: "",
    content: "The data proves that tracking effort directly impacts the end results.",
    metrics: [],
    widget: (
      <div className="flex flex-col gap-5 w-full">
         <div className="bg-emerald-900/20 border border-emerald-500/30 p-6 rounded-2xl flex items-center gap-4">
            <div className="text-4xl text-emerald-400 font-bold">40%+</div>
            <p className="text-sm font-medium text-emerald-100">Students using PenSense improve consistency by 40%+</p>
         </div>
         <div className="flex flex-col gap-2 p-4 bg-slate-900/60 border border-slate-700 rounded-xl">
            <div className="flex items-center justify-between text-sm text-slate-300"><span className="flex gap-2 items-center"><TrendUp /> Consistent Study</span></div>
            <div className="flex items-center justify-between text-sm text-slate-300"><span className="flex gap-2 items-center"><Star /> Parent Involvement</span></div>
            <div className="flex items-center justify-between text-sm text-slate-300"><span className="flex gap-2 items-center"><Check /> Better Exam Performance</span></div>
         </div>
      </div>
    )
  },
  {
    id: 13,
    eyebrow: "Vision",
    titlePrefix: "🌍 ",
    titleHighlight: "Our Vision",
    titleSuffix: "",
    content: "PenSense aims to become the default learning analytics layer for education worldwide.",
    metrics: [],
    widget: (
      <div className="flex flex-col items-center justify-center p-8 bg-gradient-to-br from-indigo-900/40 to-sky-900/30 border border-indigo-500/30 rounded-full h-64 w-64 mx-auto shadow-[0_0_50px_rgba(99,102,241,0.2)] relative text-center">
         <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#38bdf8" strokeWidth="1.5" className="mb-4"><path d="M12 2a10 10 0 0 0-7.743 16.33l-2.022 2.022a1 1 0 0 0 .708 1.708h2.022a10 10 0 1 0 7.035-20.06z"/><path d="M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0-4 0"/></svg>
         <p className="font-bold text-slate-100 mb-2 leading-tight">Every student deserves structured discipline.</p>
         <p className="text-xs text-sky-400">Analytics Layer → Personalized AI</p>
      </div>
    )
  },
  {
    id: 14,
    eyebrow: "Future Roadmap",
    titlePrefix: "🛣️ ",
    titleHighlight: "What’s Next",
    titleSuffix: "",
    content: "How we scale vertically and horizontally.",
    metrics: [],
    widget: (
      <div className="flex flex-col gap-0 w-full relative">
         <div className="absolute left-6 top-0 bottom-0 w-1 bg-slate-800 rounded-full z-0"></div>
         {[
           { time: "Phase 1", title: "Mobile App Enhancements" },
           { time: "Phase 2", title: "AI Study Recommendations" },
           { time: "Phase 3", title: "Coaching System Integration" },
           { time: "Phase 4", title: "Global Expansion" }
         ].map((r, i) => (
           <div key={i} className="flex gap-6 items-center z-10 p-3">
             <div className="w-12 h-12 bg-slate-900 border-2 border-sky-500 rounded-full flex items-center justify-center text-xs font-bold text-sky-400 shrink-0 shadow-[0_0_15px_rgba(14,165,233,0.3)]">{i+1}</div>
             <div className="bg-slate-900/80 border border-slate-700 px-4 py-3 rounded-xl flex-1">
               <span className="text-slate-200 font-medium">{r.title}</span>
             </div>
           </div>
         ))}
      </div>
    )
  },
  {
    id: 15,
    eyebrow: "Call to Action",
    titlePrefix: "📢 ",
    titleHighlight: "Partner With Us",
    titleSuffix: "",
    content: "PenSense is ready to be deployed in your institution today. Elevate your learning outcomes.",
    metrics: [],
    isCallToAction: true,
    widget: (
      <div className="bg-sky-900/20 border border-sky-500/30 rounded-2xl p-6 shadow-[0_0_40px_rgba(14,165,233,0.15)] backdrop-blur-md w-full text-center">
         <h3 className="text-2xl text-white font-bold mb-6">“Don’t wait for results. Track effort daily.”</h3>
         <div className="grid grid-cols-3 gap-2 mb-6">
            <div className="bg-slate-900/80 border border-slate-700 rounded-lg p-3 text-center">
              <p className="text-xs text-slate-400 uppercase tracking-wide">Schools</p>
              <p className="text-sm font-semibold text-sky-400 mt-1">Improve Results</p>
            </div>
            <div className="bg-slate-900/80 border border-slate-700 rounded-lg p-3 text-center">
              <p className="text-xs text-slate-400 uppercase tracking-wide">Coaches</p>
              <p className="text-sm font-semibold text-emerald-400 mt-1">Increase Success</p>
            </div>
            <div className="bg-slate-900/80 border border-slate-700 rounded-lg p-3 text-center">
              <p className="text-xs text-slate-400 uppercase tracking-wide">Parents</p>
              <p className="text-sm font-semibold text-amber-400 mt-1">Ensure Discipline</p>
            </div>
         </div>
      </div>
    )
  }
];

export default function BPlanPresentation() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  const handleNext = () => {
    if (currentSlide < SLIDES.length - 1) {
      setCurrentSlide(prev => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentSlide > 0) {
      setCurrentSlide(prev => prev - 1);
    }
  };

  const slide = SLIDES[currentSlide];

  return (
    <div className="h-screen bg-[#050B14] text-slate-100 flex flex-col font-sans overflow-hidden relative">
      
      {/* Intense Background Nebula Effects */}
      <div className="absolute top-[-20%] left-[-10%] w-[50vw] h-[50vw] rounded-full bg-indigo-900/20 blur-[120px] pointer-events-none" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[40vw] h-[40vw] rounded-full bg-sky-900/20 blur-[100px] pointer-events-none" />
      
      {/* Top Gradient Bar */}
      <div className="h-1 w-full bg-gradient-to-r from-indigo-500 via-sky-500 to-emerald-400 shrink-0 relative z-20" />
      
      {/* Header */}
      <header className="px-6 py-4 flex items-center justify-between shrink-0 h-[60px] relative z-20">
        <div className="flex items-center gap-3 min-w-0">
          <div className="flex shrink-0 h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-indigo-500 to-sky-400 text-[#050B14] font-bold shadow-lg shadow-sky-500/20 text-sm">
            P
          </div>
          <div className="min-w-0">
            <span className="font-bold text-base tracking-[0.15em] text-slate-100 uppercase block leading-none truncate">Pensense</span>
          </div>
        </div>
        <button 
          onClick={() => navigate('/')}
          className="text-xs shrink-0 font-medium text-slate-400 hover:text-slate-100 transition-colors border border-slate-800 rounded-full px-4 py-1.5 hover:bg-slate-900"
        >
          Exit Business Plan
        </button>
      </header>

      {/* Main Content Layout */}
      <main className="flex-1 w-full max-w-7xl mx-auto px-6 py-2 md:py-4 flex items-center relative z-10 transition-all duration-500 animate-in fade-in zoom-in-95" key={slide.id}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 w-full items-center">
          
          {/* Left Column: Text & Metrics */}
          <div className="flex flex-col mt-[-2rem]">
            <h3 className="text-[10px] md:text-xs font-bold tracking-[0.25em] text-sky-400 uppercase mb-3 text-shadow-sm">
              {slide.eyebrow}
            </h3>
            
            <h1 className="text-3xl md:text-5xl lg:text-[54px] font-bold tracking-tight text-white mb-5 leading-tight lg:leading-[1.1]">
              {slide.titlePrefix} 
              <span className="text-sky-400 font-extrabold">{slide.titleHighlight}</span>
              {slide.titleSuffix}
            </h1>
            
            <p className="text-lg md:text-xl lg:text-[22px] text-slate-300 leading-snug font-light mb-8 max-w-xl whitespace-pre-line">
              {slide.content}
            </p>

            {/* Glassmorphic Metrics Bar */}
            {slide.metrics.length > 0 && (
              <div className="bg-slate-900/50 backdrop-blur-xl border border-slate-700/50 rounded-xl p-3 flex flex-wrap lg:flex-nowrap gap-3 md:gap-0 justify-between shadow-[0_20px_40px_-10px_rgba(0,0,0,0.5)] w-full max-w-xl relative overflow-hidden">
                <div className="absolute inset-x-0 -top-px h-px bg-gradient-to-r from-transparent via-sky-500/50 to-transparent"></div>
                
                {slide.metrics.map((metric, idx) => (
                  <div key={idx} className={`flex items-center gap-2 px-3 ${idx !== slide.metrics.length - 1 ? 'md:border-r border-slate-800' : ''}`}>
                    <div className="shrink-0 scale-110">{metric.icon}</div>
                    <div className="flex flex-col">
                      <span className="text-sm font-bold text-slate-200">{metric.top}</span>
                      <span className="text-[11px] text-slate-400 uppercase tracking-wide">{metric.bottom}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Right Column: Widgets & CTA */}
          <div className="flex flex-col items-center justify-center w-full max-w-md mx-auto lg:mx-0 lg:ml-auto relative min-h-[300px]">
            {slide.widget}
            
            {/* CTA button rendered in the right column */}
            {slide.isCallToAction && (
              <div className="absolute inset-0 flex items-center justify-center z-20 mt-32">
                <button 
                 onClick={() => window.open('https://pensense.tech', '_blank')}
                 className="bg-sky-500 hover:bg-sky-400 text-[#050B14] font-bold tracking-wide py-3 px-8 rounded-full shadow-[0_0_20px_rgba(14,165,233,0.5)] transition-all hover:scale-105 hover:shadow-[0_0_40px_rgba(14,165,233,0.8)] flex items-center gap-2 text-base"
                >
                 Get in touch
                </button>
              </div>
            )}
          </div>
         
        </div>
      </main>

      {/* Floating Navigation Arrows - Fixed to screen edges */}
      {currentSlide > 0 && (
        <button 
          onClick={handlePrev}
          className="fixed left-2 md:left-6 lg:left-8 top-1/2 -translate-y-1/2 p-2 md:p-3 text-slate-500 hover:text-white transition-all hover:scale-110 z-50 bg-slate-900/40 hover:bg-slate-800/80 rounded-full backdrop-blur-md shadow-lg"
          aria-label="Previous Slide"
        >
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="md:w-10 md:h-10"><path d="m15 18-6-6 6-6"/></svg>
        </button>
      )}
      {currentSlide < SLIDES.length - 1 && (
        <button 
          onClick={handleNext}
          className="fixed right-2 md:right-6 lg:right-8 top-1/2 -translate-y-1/2 p-2 md:p-3 text-slate-500 hover:text-sky-400 transition-all hover:scale-110 z-50 bg-slate-900/40 hover:bg-slate-800/80 rounded-full backdrop-blur-md shadow-lg"
          aria-label="Next Slide"
        >
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="md:w-10 md:h-10"><path d="m9 18 6-6-6-6"/></svg>
        </button>
      )}

      {/* Footer / Progress */}
      <footer className="shrink-0 flex flex-col items-center justify-center px-8 pb-3 relative z-20 gap-2 mt-auto">
        <div className="flex flex-col items-center gap-1">
          <p className="text-xs font-semibold text-slate-200">Start a Pilot in Your Institute</p>
          <div className="flex items-center gap-4 text-[11px] text-sky-400/80 font-medium">
             <span className="flex items-center gap-1"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg> 9819575898</span>
             <span className="text-slate-700">|</span>
             <span className="flex items-center gap-1"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/><line x1="2" y1="12" x2="22" y2="12"/></svg> www.pensense.tech</span>
          </div>
        </div>

        <div className="flex gap-2.5 mt-1">
          {SLIDES.map((s, index) => (
            <button
              key={s.id}
              onClick={() => setCurrentSlide(index)}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                index === currentSlide 
                  ? "w-8 bg-sky-400" 
                  : "w-2 bg-slate-800 hover:bg-slate-600"
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </footer>
    </div>
  );
}
